import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"{{local-class \"block\" from=\"@qonto/ui-kit/components/placeholder/block.module.css\"}}\" style={{this.style}} ...attributes></div>", {
  moduleName: "@qonto/ui-kit/components/placeholder/block.hbs"
});